import { Box } from '@wix/design-system';
import React from 'react';
import { dataHooks } from '../../../utils/datahooks';
import { CompletedTask } from '../../rule-layout/completed-task/completed-task';
export const DropdownFixerCompletedState = _ref => {
  let {
    ruleResult,
    description,
    onEditClick,
    dataHook
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(CompletedTask, {
    completedValue: ruleResult.fixerProps.completedRuleContent.value,
    dataHook: dataHooks.completedTaskDropdownFixer(dataHook),
    description: description,
    editButtonLabel: ruleResult.fixerProps.completedRuleContent.editButtonLabel,
    inputLabel: ruleResult.fixerProps.completedRuleContent.inputTitle,
    isEditable: ruleResult.isEditableOnceCompleted,
    title: ruleResult.fixerProps.completedRuleContent.title,
    onClickEdit: () => {
      onEditClick();
    }
  }));
};
//# sourceMappingURL=dropdown-fixer-completed-state.js.map